import { Injectable } from '@angular/core';
import { IRequestParams } from '@shared/interfaces/rest/Irequest-params';
import { Observable, ReplaySubject } from 'rxjs';
import { AbsRestInfraestructure } from '@shared/helpers/abs-rest-infraestructure';
import { HttpClient } from '@angular/common/http';
import { IRestInfraestructureService } from '@shared/interfaces/rest/IRestInfraestructureService';
import { EventsService } from '../common/services/events.service';

@Injectable({
  providedIn: 'root',
})
export class RestInfraestructureService extends AbsRestInfraestructure implements IRestInfraestructureService {
  private cache = new Map<string, { subject: ReplaySubject<any>; expirationTime: number }>();

  constructor(
    protected http: HttpClient,
    event: EventsService,
  ) {
    super(http, event);
  }

  public sendRequest<T>(params: IRequestParams): Observable<T> {
    const currentTime = new Date().getTime();
    this.cache.forEach((value, key) => {
      if (currentTime > value.expirationTime) {
        this.cache.delete(key);
      }
    });

    if (!params?.cache) {
      return this.validateRequest<T>(params);
    }

    if (params.ttlMinutes || params.ttlMinutes === 0) {
      params.ttlMinutes = params.ttlMinutes === 0 ? 10 : params.ttlMinutes;
      const cacheKey = btoa(JSON.stringify(params));

      if (this.cache.has(cacheKey)) {
        const cached = this.cache.get(cacheKey)!;
        return cached.subject.asObservable();
      }

      const subject: any = new ReplaySubject<any>(1);
      const expirationTime = currentTime + params.ttlMinutes * 60 * 1000;
      this.cache.set(cacheKey, { subject, expirationTime });

      this.validateRequest<T>(params).subscribe({
        next: (response) => {
          subject.next(response);
          subject.complete();
        },
        error: (err) => {
          subject.error(err);
          this.cache.delete(cacheKey);
        },
      });

      return subject.asObservable();
    }
    return this.validateRequest<T>(params);
  }
}
